import { useState, useEffect } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { GetList } from "../../../hook/getList.tsx";
import Pagination from "../../../component/Pagination/index.tsx";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ListFame = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(1);

  const { data, search, loadMore, loading } = GetList<any>({
    url: "frame/get-list",
    isLazy: true,
    dependencies: searchValue,
    params: {
      limit: 10,
    },
  });
const list = data?.results || [];
const totalPages = data?.totalPages || 0;

  useEffect(() => {
    search("");
  }, []);


  const handlePageChange = ({ selected }: any) => {
    const newPage = selected + 1;
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
      loadMore(newPage);
    }
  };

  const handleSearch = () => {
    setPage(1);
    search(searchValue);
  };

  return (
    <div className="px-10">
      <div className="text-2xl text-center text-[pink] font-bold my-5">
        DANH SÁCH FRAME
      </div>
      <div className="flex justify-center w-full">
        <div
          className="
        flex 
        items-center 
        border-[1.5px] 
        md:w-[50%]
        w-full
        rounded-lg
        pl-2
        border-[pink]
        mb-3
        "
        >
          <input
            className="flex w-full px-2 py-2 outline-none "
            placeholder="Tìm kiếm frame"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
          <button
            onClick={handleSearch}
            className="bg-[pink] px-3 h-full rounded-tr-lg rounded-br-lg"
          >
            <AiOutlineSearch size={26} />
          </button>
        </div>
      </div>
      <div className="mt-6 max-w-7xl mx-auto w-full px-4">
        {loading ? (
          <div className="w-full h-full flex justify-center items-center mt-24">
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <div className="bg-white rounded-3xl shadow-lg border-2 border-[pink]/20 overflow-hidden">
            
            {list?.length > 0 ? (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-[pink]">
                      <tr>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">STT</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Hình ảnh</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Tên Frame</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Index</th>
                        <th className="text-left py-4 px-6 font-semibold text-white border-b border-white/20">Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item: any, index: number) => (
                        <tr
                          key={index}
                          className="border-b border-gray-100 hover:bg-[pink]/5 transition-colors"
                        >
                          <td className="py-4 px-6 font-medium text-gray-700">{(page - 1) * 10 + index + 1}</td>
                          <td className="py-4 px-6">
                            <img
                              className="w-16 h-16 object-cover rounded-xl border-2 border-[pink]/20 shadow-sm"
                              src={item?.url?.replace("http://27.71.26.120","https://phototimevn.com")}
                              alt={item?.name}
                            />
                          </td>
                          <td className="py-4 px-6">
                            <div className="font-semibold text-gray-800">{item?.name || "-"}</div>
                          </td>
                          <td className="py-4 px-6">
                            <div className="text-gray-600">{item?.index || "-"}</div>
                          </td>
                          <td className="py-4 px-6">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/admin/add-frame", { state: { item } });
                              }}
                              className="px-4 py-2 text-sm rounded-lg bg-[pink] text-white hover:bg-[pink]/80 transition-all duration-200 shadow-sm hover:shadow-md"
                            >
                              Chỉnh sửa
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                  <Pagination
                    pageCount={totalPages}
                    onPageChange={handlePageChange}
                    currentPage={page}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={2}
                  />
                </div>
              </>
            ) : (
              <div className="text-center text-gray-500 py-16">
                <div className="text-4xl mb-4">📋</div>
                <div className="text-lg font-medium">Không có dữ liệu</div>
                <div className="text-sm">Vui lòng thử lại sau</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListFame;
